export default __webpack_public_path__ + "static/media/yeopen_main_mobile_small@2x.f53d0fd3.jpg";